'use client';

import { Amplify } from 'aws-amplify';
import awsExports from '@/api/amplify/amplify.config';
import { getCustomHeader } from '@/api/amplify/helpers';
import { apiEndpoints } from '@/api/amplify/apiEndpoints';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { defaultStorage } from 'aws-amplify/utils';
Amplify.configure(awsExports, {
  API: {
    REST: {
      headers: getCustomHeader,
    },
  },
});

const existingConfig = Amplify.getConfig();

Amplify.configure({
  ...existingConfig,
  API: {
    ...existingConfig.API,
    REST: {
      ...existingConfig.API?.REST,
      ...apiEndpoints,
    },
  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);

export default function ConfigureAmplifyClientSide() {
  return null;
}
